module.exports = __webpack_public_path__ + "img/index_dev.5c13e88e.png";